// extracted by mini-css-extract-plugin
module.exports = {"benefit":"benefit_style_benefit__RGsZk","benefit-icon":"benefit_style_benefit-icon__24P9j","benefit-desc":"benefit_style_benefit-desc__3Him_"};